import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICustomApp } from '@sv/interfaces';
import { customApp } from '../../_configuration/configuration';

@Injectable({
  providedIn: 'root'
})
export class CustomAppService {
  // Initial Workshop. If this is loaded by accident the keynote component will abort the loading process
  notLoaded: ICustomApp = customApp;

  customAppListener = new BehaviorSubject<ICustomApp>(this.notLoaded);
  boothSearchValue = new BehaviorSubject<string | null>('');
  expoActive = new BehaviorSubject<string>(undefined);
  boothActive = new BehaviorSubject<boolean>(false);
  collectionActive = new BehaviorSubject<string>(undefined);

  constructor() {}

  getCustomAppListener() {
    return this.customAppListener.asObservable();
  }

  setCustomApp(app: ICustomApp) {
    this.customAppListener.next(app);
  }

  pushNewSearchValue(value: string | null) {
    this.boothSearchValue.next(value);
  }

  getboothSearchValue() {
    return this.boothSearchValue.asObservable();
  }

  setExpoActive(val: string) {
    this.expoActive.next(val);
  }

  setBoothActive(val: boolean) {
    this.boothActive.next(val);
  }

  setCollectionActive(val: string) {
    this.collectionActive.next(val);
  }

  getBoothActive() {
    return this.boothActive.asObservable();
  }

  getExpoActive() {
    return this.expoActive.asObservable();
  }

  getCollectionActive() {
    return this.collectionActive.asObservable();
  }
}
